<template>
  <div>
    <PageDynamicBreadcrumb custom-current-page="Overview" />
    <PageHeader title="Featured Keywords Overview">
      <template v-slot:actions>
        <q-btn
          label="New Featured Keyword"
          color="primary"
          to="/manage/keywords/featured/create"
        />
      </template>
    </PageHeader>

    <DataTable
      table-key="keywordsFeaturedOverview"
      row-key="id"
      title="Featured Keywords"
      :columns="columns"
      :rows="featuredKeywordsList"
      :loading="loading"
      :downloadable="true"
      :refreshable="false"
      :customizable="false"
      :filterable="true"
      :searchable="true"
      :disable-state="true"
    >
      <template v-slot:actions="row">
        <ActionsDropdownButton
          :actions="[
            {
              action: () => promptDeleteFeaturedKeyword(row),
              label: 'Delete'
            }
          ]"
        />
      </template>
    </DataTable>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import PageHeader from "@/components/UI/PageHeader";
import PageDynamicBreadcrumb from "@/components/UI/PageDynamicBreadcrumb";
import DataTable from "@/components/DataTable";
import ActionsDropdownButton from "@/components/UI/ActionsDropdownButton";
import ConfirmationModalDelete from "@/components/UI/ConfirmationModalDelete";
import { Dialog } from "quasar";
moment.locale("en");

export default {
  name: "KeywordsFeaturedOverview",
  components: {
    ActionsDropdownButton,
    DataTable,
    PageDynamicBreadcrumb,
    PageHeader
  },
  data() {
    return {
      loading: true,
      featuredKeywordsList: [],
      columns: [
        {
          name: "business_account_id",
          label: "Business Account ID",
          field: "business_account_id",
          sortable: true,
          sort: (a, b) => this.sortInteger(a, b),
          type: "dimension"
        },
        {
          name: "business_account_name",
          label: "Business Account Name",
          field: "business_account_name",
          sortable: true,
          type: "dimension"
        },
        {
          name: "keyword_id",
          label: "Keyword ID",
          field: "keyword_id",
          sortable: true,
          sort: (a, b) => this.sortInteger(a, b),
          type: "dimension"
        },
        {
          name: "keyword",
          label: "Keyword",
          field: "keyword",
          sortable: true,
          type: "dimension"
        },
        {
          name: "product_category",
          label: "Product Category",
          field: "category",
          sortable: true,
          type: "dimension"
        },
        {
          name: "time_created",
          label: "Time Excluded",
          field: row => moment.utc(row.time_created).local(),
          format: val =>
            !val
              ? "-"
              : moment
                  .utc(val)
                  .local()
                  .format("lll"),
          sortable: true,
          sort: (a, b) => this.sortDate(a, b),
          type: "metric",
          metricType: "date"
        },
        {
          name: "actions",
          label: "",
          field: "",
          filterable: false
        }
      ]
    };
  },
  computed: {},
  mounted() {
    this.fetchFeaturedKeywords();
  },
  methods: {
    fetchFeaturedKeywords() {
      axios({
        url: "https://api-v2.jumpfeed.com/internal/keywords/featured"
      })
        .then(resp => {
          this.featuredKeywordsList = resp.data.data;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    promptDeleteFeaturedKeyword(featuredKeyword) {
      Dialog.create({
        component: ConfirmationModalDelete,
        componentProps: {
          descriptor:
            featuredKeyword.keyword + " (" + featuredKeyword.keyword_id + ")"
        }
      }).onOk(dialog => {
        dialog.submitting = true;
        axios
          .post(
            "https://api-v2.jumpfeed.com/internal/keywords/featured/delete",
            {
              id: featuredKeyword.id
            }
          )
          .then(() => {
            this.triggerActionOutcomeAlert("delete", true);
            dialog.hide();
            this.fetchFeaturedKeywords();
          })
          .catch(err => {
            console.log(err);
            this.triggerActionOutcomeAlert("delete", false);
          })
          .finally(() => {
            dialog.submitting = false;
          });
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
